(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('transition', ['$timeout', function ajaxFactory($timeout) {
            this.end = function (el, callback, repeating) {
                if (config.noTransitionEnd) {
                    $timeout(function () {
                        callback.call(el);
                    }, 10);
                } else {
                    el.off('transitionend').on('transitionend', function () {
                        if (!repeating) {
                            el.off('transitionend');
                        }

                        callback.call(el);
                    });
                }
            };

            return this;
        }]);
}());
